module.exports = __webpack_public_path__ + "img/karuizawa_MaaS_logo_D.aa694b2c.jpg";